<template>
  <CBreadcrumb v-if="isShowBreadcrumbs" class="d-md-down-none me-auto mb-0">
    <CBreadcrumbItem class="breadcrumb-link" v-for="item in breadcrumbs" :key="item" :active="item.active">
      <router-link v-if="!item.active" :to="item.path">
        {{ $t(`sidebar.${item.name}`) }}
      </router-link>
      <span v-else>
        {{ $t(`sidebar.${item.name}`) }}
      </span>
    </CBreadcrumbItem>
  </CBreadcrumb>

  <div v-else class="header-wrapper">
    <h4>
      {{ $t('general.space') }} - {{ $t('dashboard.week') }} {{ currentWeek }} ({{ currentMonthYear }})
    </h4>
    <div v-if="beginDayState" class="content-header-wrapper" style="justify-content: flex-end">
      <CButton @click="setDayEnding" color="primary" size="sm" class="float-end mt-2 main-primary-btn">
        {{ $t('dashboard.addReport') }}
      </CButton>
    </div>
  </div>

  <teleport to="body">
    <AddReportModal @closeReportForm="closeReportForm" :showEndWorkingDayModal="showEndWorkingDayModal" />
  </teleport>
</template>

<script>

import AddReportModal from '@/components/dashboard/AddReportModal.vue'
export default {
  name: 'AppBreadcrumb',
  components: {
    AddReportModal
  },
  data() {
    return {
      breadcrumbs: [],
      showEndWorkingDayModal: false
    }
  },

  computed: {
    isShowBreadcrumbs() {
      return this.$route.fullPath !== '/dashboard'
    },

    currentWeek() {
      const today = new Date()
      const firstDayOfYear = new Date(today.getFullYear(), 0, 1)
      const pastDays = (today - firstDayOfYear) / (1000 * 60 * 60 * 24)
      return Math.ceil((pastDays + firstDayOfYear.getDay() + 1) / 7)
    },

    currentMonthYear() {
      const today = new Date()
      return today.toLocaleDateString(this.$i18n.locale, {
        month: 'long',
        year: 'numeric',
      })
    },

    beginDayState() {
      return this.$store.getters['reports/getBeginDayStatus']
    },
  },

  mounted() {
    this.breadcrumbs = this.getBreadcrumbs()

    this.unwatch = this.$router.afterEach(() => {
      this.breadcrumbs = this.getBreadcrumbs()
    })
  },

  beforeUnmount() {
    if (this.unwatch) this.unwatch()
  },

  methods: {
    getBreadcrumbs() {
      const currentRoute = this.$route
      return currentRoute.matched.map((routeRecord, index, matched) => {
        const resolved = this.$router.resolve({
          name: routeRecord.name,
          params: currentRoute.params,
          query: currentRoute.query,
        })
        return {
          active: routeRecord === matched[matched.length - 1],
          name: routeRecord.name,
          path: resolved.href,
        }
      })
    },

    setDayEnding() {
      this.showEndWorkingDayModal = true
    },

    closeReportForm() {
      this.showEndWorkingDayModal = false
    },
  },
}
</script>

<style lang="scss" scoped>
.breadcrumb-link {
  @media screen and (max-width: 768px) {
    font-size: 14px;
  }
}

.header-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>

